(function () {
  'use strict';

  function initMbcg(root) {
    if (!root || root.dataset.mbcgInit) return;
    root.dataset.mbcgInit = 'true';

    var list = root.querySelector('[data-mbcg-list]');
    var content = root.querySelector('[data-mbcg-content]');
    if (!list || !content) return;

    function activate(id) {
      root.querySelectorAll('[data-mbcg-item]').forEach(function (el) {
        el.classList.toggle('is--active', el.dataset.catId === id);
      });
      root.querySelectorAll('[data-mbcg-panel]').forEach(function (el) {
        el.classList.toggle('is--active', el.dataset.catId === id);
      });
      content.scrollTop = 0;
    }

    list.addEventListener('click', function (e) {
      var item = e.target.closest('[data-mbcg-item]');
      if (item) activate(item.dataset.catId);
    });

    content.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      var head = e.target.closest('[data-mbcg-group-toggle]');
      if (!head) return;
      var group = head.closest('[data-mbcg-group]');
      if (group && group.classList.contains('is--foldable')) {
        group.classList.toggle('is--open');
      }
    });

    list.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var item = e.target.closest('[data-mbcg-item]');
      if (item) {
        e.preventDefault();
        activate(item.dataset.catId);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mbcg]').forEach(initMbcg);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var drawer = document.getElementById('t4s-menu-drawer');
  if (drawer && window.MutationObserver) {
    new MutationObserver(initAll).observe(drawer, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', initAll);
})();
